import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control} from 'react-hook-form';

import {Card} from 'shells/card/card';
import {Checkbox} from 'shells/checkbox/checkbox';
import {ColorPicker} from 'shells/color-picker/color-picker';
import {FormField} from 'shells/form/form-field';

import {FormFontPicker} from '../fonts/form-font-picker';

import styles from './design-form.module.css';

type Props = {
    control: Control;
};

export function FormDesignForm(props: Props) {
    return (
        <div className='flex-grow'>
            <Card hasBorder={true} hasShadow={true}>
                <div className={styles['design-form']}>
                    <div className={styles.header}>Form design</div>
                    <div className={styles['design-fields-container']}>
                        <FormField innerId='backgroundColor' label='Background color'>
                            <Controller
                                name='backgroundColor'
                                control={props.control}
                                // @ts-expect-error
                                render={({field}) => (
                                    <ColorPicker
                                        currentColor={field.value}
                                        onSetCurrentColor={field.onChange}
                                        showTransparent={true}
                                    />
                                )}
                            />
                        </FormField>
                        <FormField innerId='fontStyle' label='Font'>
                            <div className='mb-16'>
                                <Controller
                                    name='fontStyle'
                                    control={props.control}
                                    // @ts-expect-error
                                    render={({field}) => {
                                        const {ref, ...rest} = field;

                                        // We remove ref from field and pass it as pickerRef to avoid
                                        // an error passing ref directly to SelectPickerGeneric
                                        return (
                                            <FormFontPicker
                                                {...rest}
                                                pickerRef={ref}
                                                selectOnFocus={true}
                                            />
                                        );
                                    }}
                                />
                            </div>
                            <Controller
                                name='fontStyle.inheritWhenEmbedded'
                                control={props.control}
                                defaultValue={false}
                                // @ts-expect-error
                                render={({field}) => (
                                    <Checkbox
                                        {...field}
                                        checked={field.value}
                                        isLarge={true}
                                        label='Use your website’s font on embedded forms'
                                    />
                                )}
                            />
                        </FormField>
                    </div>
                </div>
            </Card>
        </div>
    );
}
